import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    cards: [],
    loaded: false,
    cardModelDef: {
        id: null,
        bot_id: null,
        card_list_id: null,
        updated_at: null,
        created_at: null,
        status: 1,
        user_id: null,
        type: null,
        title: null,
        description: null,
        count: 0,
        tags: null
    },
    cardLists: [],
    unsortedCardListId: null,
    cardSortedInList: {},
    unsortedCards: [],
    cardListsLoaded: false,
    cardsLoaded: false,
    cardListModelDef: {
        id: null,
        bot_id: null,
        card_category_id: null,
        status: 1,
        cards: null,
        created_at: null,
        title: '',
        type: 1
    },
    cardComments: [],
    cardCommentModelDef: {
        id: null,
        bot_id: null,
        created_at: null,
        status: 1,
        type: 0,
        description: null,
        is_bot: 1,
        user_id: null
    },
    cardCategories: [],
    cardCategoriesLoaded: false,
    cardCategoryFormShow: false,
    cardCategoryModelDef: {
        id: null,
        bot_id: null,
        title: '',
        status: 1,
        created_at: null
    },
    lastLoadedCategoryId: null,
    tags: [],
    cardTagsInCard: [],
    deliveries: [],
    promos: []
}
export default {
    state,
    getters,
    actions,
    mutations
}
